module.exports = __WEBPACK_EXTERNAL_MODULE_58__;


//////////////////
// WEBPACK FOOTER
// external "@angular/common"
// module id = 58
// module chunks = 0